// extracted by mini-css-extract-plugin
export default {"searchMenu":"SearchMenu_searchMenu__uxyfz","spacer":"SearchMenu_spacer__GqK0B"};